module.exports = __webpack_public_path__ + "static/media/marker_bubble_drag_hover.970b3972.svg";